import { Pipe, PipeTransform } from '@angular/core';
import { escapeRegExp } from '@schoolbelle/common/functions';
@Pipe({
  name: 'highlight'
})
export class HighlightPipe implements PipeTransform {
  transform(str: string, key?: string): any {
    if (!str || typeof str !== 'string') {
      return str;
    }
    if (!key) return str;
    key.split(' ').filter(bit=>bit).forEach(bit => {
      let regex = new RegExp(escapeRegExp(bit), 'ig');
      str = str.replace(regex, '<strong>' + bit + '</strong>');
    });
    return str;
  }
}
